import styled from "styled-components";

export const StyleTimeSheet = styled.div`
    text-align: left;
    padding-bottom: 4rem;
    background-color:${(p) => p.theme.colors.white02};

    .csvExportDiv {
        // border-top: 1px solid ${(p) => p.theme.colors.lightgray09};
        padding: 2rem;
        gap: 2rem;
        margin-top:1rem;
        width: 100%;
        text-align: left;

        @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 0;
            text-align:center;
        }
    }
    .csvExportTitle {
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
        font-weight: 700;
        font-size: 1.6rem;
        color:${(p) => p.theme.colors.black01};

    }

    .dateContainer {
    width:100%;
    display: flex;

      @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            flex-direction: column;
            gap: 0.8rem;
            margin-bottom:1rem;
        }
    }

    .dateSubContainer {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 100%;
      @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            justify-content: space-between;
        }
    }

    .inputMonth {
        padding: 1rem;
        border-radius: 24px;
        color:${(p) => p.theme.colors.black01};
        background-color:${(p) => p.theme.colors.white02};
        border: 1px solid ${(p) => p.theme.colors.gray03};
        font-size: 1.5rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;

        @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            margin-bottom:1rem;
            width:100%;
        }
    }

    .wrapperSelectGroup {
       width: 18rem;
       @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            width:100%;
        }

    }


    .wrapperDatePicker {
                width: 18rem;
            }
    .inputDate {
        flex:1;
        width100%;
        padding: 1rem;
        border-radius: 24px;
        border: 1px solid ${(p) => p.theme.colors.gray03};
        background-color:${(p) => p.theme.colors.white02};
        font-size: 1.5rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
        margin-right:0.5rem;
        margin-left:0.5rem;
        @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
        width:70%;
        }
    }
    .tsDatePicker {
      margin-top:1rem;
      display: flex;
      align-items: center;
      gap: 1rem;
      @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
      width:100%;
      display: block;
      }
      .label {
          display: flex;
          align-items: center;
          width:14rem;
      }
    }


    .timesheet {
        padding: 1rem 1.5rem;
        min-height: 80vh;
        @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
            padding: 2rem 2rem;
        }
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            padding: 2rem 2rem;
        }
            margin-top:7rem;
            padding-bottom:8rem;
        .to-link {
            // display: flex;
        }
        &__title {
            padding-bottom: 1rem;
        }
        &__datePicker {
            display: flex;
            align-items:center;
            justify-content:space-between;
            @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
             display: block;
             justify-content:none;
            }
            .label {
                display: flex;
                align-items: center;
                width:8rem;
                // padding-right: 2rem;
            }
            .wrapperDatePicker {
                width: 18rem;
              @media (max-width: ${(p) => p.theme.breakPoints.breakMedium}) {
              width:100%;
              margin-bottom:1rem;
             }

            }
        }
        &__form {
            @media (min-width: ${(p) => p.theme.breakPoints.breakBig}) {
                display: flex;
                justify-content: space-between;
            }
        }
        &__filter {
            padding: 2rem 0;
            display: flex;
            overflow-y: auto;
            column-gap: 0.5rem;
            margin-bottom: 2rem;
            @media (min-width: ${(p) => p.theme.breakPoints.breakTablet}) {
                width: 100%;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1rem;
                grid-template-columns: auto auto auto auto;
            }
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                max-width: 80rem;
                margin-bottom: 0;
            }
            .active {
                border: 1px solid ${(p) => p.theme.colors.secondary} !important;
                .title {
                    color: ${(p) => p.theme.colors.secondary}!important;
                }
            }
            &-item {
                display: flex;
                padding: 0.5rem 1rem;
                border-radius: 1.6rem;
                border: 1px solid ${(p) => p.theme.colors.darkBlack};
                justify-content: center;
                cursor: pointer;
                min-width: 12rem;
                .title {
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                    padding-right: 1rem;
                    display: block;
                    display: -webkit-box;
                    max-width: 100%;
                    height: 20px;
                    line-height: 1.2;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        &__search {
            // display: flex;
            // align-items: center;
            // @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            //     width: 30rem;
            // }
            .wrapperSelect {
                width: 100%;
            }
        }
        &__calendar {
            padding-top: 2rem;
        }
    }
`;

export const StyledTimeSheetCalendar = styled.div`
    min-height: 80rem;
    background-color: ${(p) => p.theme.colors.white00};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    color:${(p) => p.theme.colors.black01};

    .rbc-day-bg.holiday-bg {
  background-color:${(p) => p.theme.colors.red05} !important;
}

    .rbc-calendar {
        min-height: 80rem;
    }
    .rbc-header {
    background-color: ${(p) => p.theme.colors.lightgray09};
    }
    .rbc-event,
    .rbc-day-slot .rbc-background-event {
        background-color:transparent;
    }

    .rbc-agenda-date-cell.holiday-bg {
      color: ${(p) => p.theme.colors.red05} !important;
      font-weight:bold;
    }

    .rbc-day-slot .rbc-background-event.holiday-bg {
        background-color: ${(p) => p.theme.colors.red05}!important;
    }
    .rbc-month-row {
        overflow: visible !important;
    }
    .rbc-toolbar {
        display: none;
    }
    .rbc-row:nth-of-type(2) {
      flex-grow: 1;
    }
    .rbc-event {
        cursor: pointer;
        position: relative;
        height: 100%;
        max-height: 180px;
        overflow-y: auto;
        z-index: 10;
    }
    .rbc-event:hover {
        scrollbar-width: 3px;
        overflow-y: auto;
    }
    .rbc-event::-webkit-scrollbar {
        width: 4px;
    }

    .rbc-event::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }

    .rbc-event::-webkit-scrollbar-thumb {
        background-color: #999;
        border-radius: 4px;
    }

    .rbc-event::-webkit-scrollbar-thumb:hover {
        background-color: #888;
    }
    .rbc-event:focus {
        outline: none;
    }
    .rbc-row-content {
        position: relative;
        user-select: auto;
        /* -webkit-user-select: none; */
        z-index: 10;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .rbc-selected-cell {
        background: transparent;
    }
    .rbc-today {
        background-color: transparent;
    }
    .rbc-agenda-time-cell {
        display: none !important;
    }
    .rbc-agenda-event-cell {
        border-left:none !important;
    }
    .rbc-agenda-view table thead tr {
        display: none !important;
    }

`;
export const StyledEventContent = styled.div`
    .groupUser {
        .mine {
            .content {
                background-color: #b0eefc !important;
                padding: 0.4rem !important ;
            }
            border-radius: 1rem !important;
        }
        .user {
            display: flex;
            flex-direction: column;
            color: ${(p) => p.theme.colors.darkBlack};
            .more {
                &__dot {
                    padding: 0.2rem 0.8rem;
                    text-align: center;
                    @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                        display: none;
                    }
                }
            }
            .wrapperAvatar {
                padding: 0.5rem;
                display: flex;
                z-index: 10;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem 1.5rem;
                }
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem;
                    border-radius: 1rem;
                    padding: 0.5rem 0.8rem;
                }
            }
            .content {
                display: flex;
                background-color: #e7e7e7;
                padding: 0;
                border-radius: 1.6rem;
                align-items: center;

                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    padding: 0.5rem 1rem;
                }
            }
            .name {
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
                font-weight: 500;
                font-size: 1.4rem;
                text-align: center;
                // display: none;
                @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                    display: block;
                    display: -webkit-box;
                    max-width: 9rem;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding-left: 1rem;
                }
            }
            .MuiAvatar-root {
                width: 2.5rem;
                height: 2.5rem;
            }
        }
    }
    .mobile {
        &__dot {
            @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
                display: none;
            }
        }
    }
    .more__text {
        display: none;
        font-size: 1.3rem;
        padding-left: 2rem;
        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
        font-weight: 500;
        color: #656565;
        @media (min-width: ${(p) => p.theme.breakPoints.breakMedium}) {
            display: block;
        }
    }
`;
export const StyledTimeSheetContentModal = styled.div`
    padding: 2.5rem 4rem;

    .toggle {
        &__top {
            &-collapse {
                display: flex;
            }
            .collapse-title {
                font-size: 1.4rem;
            }
            padding-bottom: 2.4rem;
            &-date {
                font-size: 3.6rem;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
            }
            &-icon {
                width: 2.5rem;
                height: 2.5rem;
                cursor: pointer;
            }
        }
        &__user {
            margin-top: 3rem;
            margin-bottom: 3rem;
            cursor: pointer;
            &-item {
                display: flex;
                padding: 0.6rem 1.2rem;
                background-color: #b0eefc;
                border-radius: 24px;
                margin-bottom: 2rem;
            }
            &-name {
                padding-top: 1rem;
                padding-left: 1rem;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
                font-size: 1.4rem;
                display: flex;
                align-items: center;
                height: 3.5rem;
                display: -webkit-box;
                max-width: 100%;
                line-height: 1.2;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            &-btn {
            width:100%;
            }
        }
        .wrapperList {
            max-height: 70vh;
            overflow-y: auto;
        }
        &__groupUser {
            padding-top: 2rem;
            padding-bottom: 2rem;
            &-title {
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                font-weight: 700;
                font-size: 1.6rem;
            }
            &-list {
                padding-left: 2rem;

                .item {
                    padding: 1rem 0;
                    display: flex;
                    cursor: pointer;
                    &__title {
                        margin-top: 1rem;
                        padding-left: 1rem;
                        font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                        font-weight: 700;
                        font-size: 1.4rem;
                        display: flex;
                        align-items: center;
                        height: 3.5rem;
                        display: -webkit-box;
                        max-width: 100%;
                        line-height: 1.2;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
`;
export const StyledPopoverList = styled.div`
    display: flex;
    flex-direction: column;
    .wrapItem {
        border-radius:6px;
        padding: 2rem;
        cursor: pointer;
        transition: 250ms;
        display: flex;
        justify-content: flex-end;
        &:hover {
            background-color: #43cdec;
        }
    }
    .item {
        font-size: 1.4rem;
        padding: 0 !important;
        &__status {
            padding-left: 1rem;

            &-checked {
                padding: 0.4rem 1rem;
                background-color: #d6fddc;
                display: flex;
                border-radius:6px;
                .text {
                    padding-right: 0.5rem;
                    color: #0aba3b;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-unChecked {
                padding: 0.4rem 1rem;
                background-color: #fdd6d6;
                border-radius:6px;
                display: flex;
                .text {
                    padding-right: 0.5rem;
                    color: #ba0a0a;
                    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_700};
                    font-weight: 700;
                }
                .icon {
                    display: block;
                    padding-top: 0.1rem;
                }
            }
            &-pending {
                border-radius:6px;
                padding: 0.4rem 1rem;
                background-color: #e9e9e9;
            }
        }
    }
`;

export const WideButton = styled.div<{ disabled?: boolean }>`
padding: 1rem 3rem;
border-radius: 50px;
font-weight: bold;
transition: all 0.3s;
width:100%;
text-align : center;
font-size : 12px;
cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
height:4rem;
background-color: ${({ theme, disabled }) => (disabled ? theme.colors.gray03 : theme.colors.orange)};
color: ${(p)=>p.theme.colors.white00};

&:hover {
    background-color: ${({ theme, disabled }) => (disabled ? theme.colors.gray03 : theme.colors.yellow08)};
  }
&:focus {
    outline: ${({ theme, disabled }) => (disabled ? "none" : `2px solid ${theme.colors.lightgray09}`)};
  }
`;
